@if (attachments().length) {
  <div
    #attachmentContainer
    class="flex items-center justify-between gap-sm w-[min(11rem,calc(100vw-1rem))]">
    <div class="flex items-center gap-sm">
      <lib-invoice-attachment-icon [iconClass]="'text-primary-500 size-4'" />

      <span class="text-sm text-neutral-900">
        {{ attachments().length }} {{ label() }}
      </span>
    </div>

    <button
      type="button"
      name="attachmentPreviewToggle"
      class="bg-transparent cursor-pointer flex items-center"
      dropdownOverlay
      [(isOpen)]="isMenuOpen"
      [matchWidth]="false"
      [origin]="attachmentContainer"
      [panelClass]="panelClass()"
      popupRole="menu"
      (click)="$event.stopPropagation()">
      <lib-chevron-down-icon
        [iconClass]="
          'size-5 text-primary-500 transition-transform ' +
          (isMenuOpen() ? 'rotate-180' : '')
        " />

      <ng-template #dropdownContent>
        <div
          class="flex flex-col bg-white shadow-xl rounded-lg items-center gap-sm py-lg max-h-[21rem] min-h-20 overflow-x-hidden overflow-y-auto w-[min(15rem,calc(100vw-1rem))]"
          role="menu">
          @for (item of attachments(); track $index) {
            <a
              class="w-full flex items-center justify-between gap-md text-sm text-neutral-900 py-sm px-lg hover-state"
              role="menuitem"
              [href]="item.url"
              target="_blank"
              rel="noopener noreferrer">
              <div class="flex items-center gap-md">
                <lib-file-icon [iconClass]="'text-primary-500 size-8'" />

                <span class="text-base text-neutral-900">
                  {{ item.name | truncate: 12 }}
                </span>
              </div>

              <div class="flex">
                <lib-file-download-icon
                  [iconClass]="'text-primary-500 size-6'" />
              </div>
            </a>
          }
        </div>
      </ng-template>
    </button>
  </div>
}
